import React from "react";
import { SVG } from '../../types/svg.ts'

// 24

export default ({
	height,
	width,
	style,
	className,
	fill,
}: SVG) => {
  return (
     <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
			height={height}
			width={width}
			style={style}
			fill={fill}
			
			stroke="#303030"
      viewBox="0 0 26 26"
    >
      <g fillRule="evenodd">
        <path
          strokeWidth="2"
          d="M9 17l3-2.94a9.34 9.34 0 00-1-.06c-2.67 0-8 1.34-8 4v2h9l-3-3zm2-5c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4"
        ></path>
        <path
          fill="#303030"
          stroke="none"
          d="M15.47 20.5L12 17l1.4-1.41 2.07 2.08 5.13-5.17 1.4 1.41z"
        ></path>
      </g>
    </svg>
  );
}
